<template>
  <div id="app">
    <app-header />
    <main>
  
      <router-view />
    </main>
    <app-footer id="app-footer" /> 
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
  },
  // data, watch, mounted 中关于 i18n 的部分保持不变
  watch: {
    '$i18n.locale': function(newLocale) {
      document.documentElement.lang = newLocale === 'zh' ? 'zh-CN' : newLocale;
      document.title = this.$t('appTitle') || 'RE Peak(HK) Co.,Limited';
    }
  },
  mounted() {
    if (this.$i18n && this.$i18n.locale) {
      document.documentElement.lang = this.$i18n.locale === 'zh' ? 'zh-CN' : this.$i18n.locale;
      document.title = this.$t('appTitle') || 'RE Peak(HK) Co.,Limited';
    } else {
      console.error("Vue I18n instance not available at component mount in App.vue.");
      document.documentElement.lang = 'zh-CN';
      document.title = 'RE Peak(HK) Co.,Limited';
    }
  }
};
</script>

<style>
/* 全局样式保持不变 */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fff;
  line-height: 1.6;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex-grow: 1;
  /* (可选) 如果 header 是 sticky/fixed 定位，可能需要给 main 加一个 padding-top */
  /* padding-top: 71px; */ /* 假设你的 header 高度是 71px */
}
</style>